module.exports = __webpack_public_path__ + "static/media/webLogo.28b0c4c6.svg";